let slideIndex=1,startX=0,endX=0;function plusSlides(e){showSlides(slideIndex+=e)}function currentSlide(e){showSlides(slideIndex=e)}function showSlides(e){const s=document.getElementsByClassName("mySlides"),t=document.getElementsByClassName("dot");e>s.length&&(slideIndex=1),e<1&&(slideIndex=s.length);for(let e=0;e<s.length;e++)s[e].style.display="none",s[e].setAttribute("aria-hidden","true");for(let e=0;e<t.length;e++)t[e].classList.remove("c-active"),t[e].setAttribute("aria-selected","false");s[slideIndex-1].style.display="block",s[slideIndex-1].setAttribute("aria-hidden","false"),t[slideIndex-1].classList.add("c-active"),t[slideIndex-1].setAttribute("aria-selected","true")}showSlides(slideIndex);const slideshow=document.getElementById("slideshow");function handleSwipe(){startX-endX>50?plusSlides(1):endX-startX>50&&plusSlides(-1)}slideshow&&(slideshow.addEventListener("touchstart",e=>{startX=e.touches[0].clientX}),slideshow.addEventListener("touchend",e=>{endX=e.changedTouches[0].clientX,handleSwipe()}));

// function initSlideshow(){const e=6e3,t=400,n=50,i=4e3,l=[...document.querySelectorAll(".mySlides")],d=[...document.querySelectorAll(".dot")],o=document.getElementById("slideshow"),c=document.querySelector(".next"),r=document.querySelector(".prev");if(!l.length)return console.warn("No slides found");let a=1,s=null,u=null,h={x:0,y:0},m=!1;function f(e){if(m)return;m=!0,a=e>l.length?1:e<1?l.length:e,l.forEach((e,t)=>{e.style.display=t===a-1?"block":"none",e.setAttribute("aria-hidden",t!==a-1)}),d.forEach((e,t)=>{e.classList.toggle("c-active",t===a-1),e.setAttribute("aria-selected",t===a-1)}),setTimeout(()=>{m=!1},t)}function y(e){v(),f(a+e)}function g(e){v(),f(e)}function p(){clearTimeout(s),s=setTimeout(()=>{f(a+1),p()},e)}function v(){clearTimeout(s),clearTimeout(u),u=setTimeout(()=>{p()},i)}function w(e){const t=e.touches?.[0]||e;h={x:t.clientX,y:t.clientY},v()}function b(e){const t=e.changedTouches?.[0]||e,n=h.x-t.clientX,i=h.y-t.clientY;Math.abs(n)>Math.abs(i)&&Math.abs(n)>50&&y(n>0?1:-1)}f(a),o.addEventListener("touchstart",w,{passive:!0}),o.addEventListener("touchend",b),r?.addEventListener("click",()=>y(-1)),c?.addEventListener("click",()=>y(1)),d.forEach((e,t)=>{e.addEventListener("click",()=>g(t+1)),e.addEventListener("keydown",e=>{["Enter"," "].includes(e.key)&&(e.preventDefault(),g(t+1))})}),o.addEventListener("mouseenter",()=>clearTimeout(s)),o.addEventListener("mouseleave",()=>p()),document.addEventListener("keydown",e=>{"ArrowLeft"===e.key?y(-1):"ArrowRight"===e.key&&y(1)}),document.addEventListener("visibilitychange",()=>{document.hidden?clearTimeout(s):p()}),"IntersectionObserver"in window&&new IntersectionObserver(([e])=>{e.isIntersecting?p():clearTimeout(s)},{threshold:.3}).observe(o),l.length>1&&p(),window.plusSlides=y,window.currentSlide=g}
// document.addEventListener("DOMContentLoaded",()=>{document.getElementById("slideshow")&&initSlideshow()});

// ---- post-paint, idle-friendly boot for the slideshow ----
// (function bootSlideshow() {
//   const start = () => {
//     // Double rAF -> guarantees at least one paint before we run work
//     requestAnimationFrame(() => {
//       requestAnimationFrame(() => {
//         const run = () => {
//           const el = document.getElementById("slideshow");
//           if (el) initSlideshow(); // your existing function
//         };

//         // Prefer idle time, but don't wait forever
//         if ("requestIdleCallback" in window) {
//           requestIdleCallback(run, { timeout: 1500 });
//         } else {
//           setTimeout(run, 0);
//         }
//       });
//     });
//   };

//   // Wait for full load so images/layout can win the first paint & LCP
//   if (document.readyState === "complete") {
//     start();
//   } else {
//     window.addEventListener("load", start, { once: true });
//   }
// })();



// let slideIndex = 1;
//   let startX = 0;
//   let endX = 0;

//   showSlides(slideIndex);

//   function plusSlides(n) {
//     showSlides(slideIndex += n);
//   }

//   function currentSlide(n) {
//     showSlides(slideIndex = n);
//   }

//   function showSlides(n) {
//     const slides = document.getElementsByClassName("mySlides");
//     const dots = document.getElementsByClassName("dot");

//     if (n > slides.length) { slideIndex = 1; }
//     if (n < 1) { slideIndex = slides.length; }

//     for (let i = 0; i < slides.length; i++) {
//       slides[i].style.display = "none";
//       slides[i].setAttribute("aria-hidden", "true");
//     }

//     for (let i = 0; i < dots.length; i++) {
//       dots[i].classList.remove("c-active");
//       dots[i].setAttribute("aria-selected", "false");
//     }

//     slides[slideIndex - 1].style.display = "block";
//     slides[slideIndex - 1].setAttribute("aria-hidden", "false");
//     dots[slideIndex - 1].classList.add("c-active");
//     dots[slideIndex - 1].setAttribute("aria-selected", "true");
//   }

//   // Add swipe support
//   const slideshow = document.getElementById("slideshow");
//   if (slideshow) {
//     slideshow.addEventListener("touchstart", (e) => {
//       startX = e.touches[0].clientX;
//     });

//     slideshow.addEventListener("touchend", (e) => {
//       endX = e.changedTouches[0].clientX;
//       handleSwipe();
//     });
//   }

//   function handleSwipe() {
//     const swipeThreshold = 50; // Minimum swipe distance in px

//     if (startX - endX > swipeThreshold) {
//       // Swiped left
//       plusSlides(1);
//     } else if (endX - startX > swipeThreshold) {
//       // Swiped right
//       plusSlides(-1);
//     }
//   }